import { render } from "./FeaturesComponent.vue?vue&type=template&id=71d716a6&scoped=true"
import script from "./FeaturesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturesComponent.vue?vue&type=script&lang=js"

import "./FeaturesComponent.vue?vue&type=style&index=0&id=71d716a6&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d716a6"]])

export default __exports__